import {
  Box,
  Button,
  Container,
  FormControl,
  Typography,
  useTheme,
} from "@mui/material"
import React, { useEffect, useState } from "react"
import { generatePath, useHistory } from "react-router-dom"
import Dialog from "../../components/Dialog"
import ResponsiveBackground from "../../components/ResponsiveBackground"

import ArrowForwardIosIcon from "@mui/icons-material/ArrowForwardIos"
import InfoOutlinedIcon from "@mui/icons-material/InfoOutlined"
import ContiSpecificButton from "components/ContiSpecificButton"
import { StyledTextField } from "./styles"

import {
  ateEanCode,
  basePath,
  contiEanCode,
  isAte,
  isConti,
  isVDO,
} from "utils/Global"
import { default as general_eancode_image } from "../../assets/images/general_eancode.png"
import { useTranslation } from "react-i18next"
import BarcodeScannerComponent from "react-qr-barcode-scanner"
import { fonts_VDO } from "themes/default/tokens"

export const namespace = __filename

const SecondScan = () => {
  const theme = useTheme()
  const history = useHistory()
  const { t } = useTranslation()

  const { breakpointTablet } = theme.tokens.breakpoints
  const isMobile = window.innerWidth < breakpointTablet

  const [data, setData] = useState("")
  const [showScan, setShowScan] = useState(false)
  const [error, setError] = useState("")
  const [eanCodeImg, setEanCodeImg] = React.useState(
    basePath + general_eancode_image
  )
  const [showInfo, setShowInfo] = useState(false)
  const [showTextField, setShowTextField] = useState(!isMobile ? true : null)
  const [showPlaceholder, setShowPlaceholder] = useState(true)
  const [scanSuccess, setScanSuccess] = useState(false)

  //start quagga
  const [decodedText, setDecodedText] = useState("" as string)

  const redirectLocation = (gtin: string) => {
    setError("")
    history.replace({
      pathname: "/scan",
      search: "ean=" + gtin,
    })
    history.push({
      pathname: generatePath("/tecdoc"),
      state: {
        gtin: gtin,
      },
    })
  }

  useEffect(() => {
    if (history.location.search) {
      const parameters = new URLSearchParams(history.location.search)
      const ean = parameters.get("ean")
      if (ean && ean.length > 3) {
        setShowTextField(true)
        setDecodedText(parameters.get("ean"))
        history.replace({
          pathname: "/scan",
          search: "",
        })
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  const handleKeyDown = (event) => {
    if (event.key === "Enter") {
      eanCheck(decodedText ? decodedText : data) && redirectLocation(data)
    }
  }

  const onClickHandle = () => {
    eanCheck(decodedText ? decodedText : data) && redirectLocation(data)
  }

  const eanCheck = (input) => {
    if (!/^\d{13}$/.test(input)) {
      setError(t("eanIncorrectLength"))
      return false
    } else {
      setError("")
    }

    // Calculate the check digit using the first 12 digits
    let checkDigit = 0
    for (let i = 0; i < 12; i += 2) {
      checkDigit += Number(input[i])
      checkDigit += Number(input[i + 1]) * 3
    }
    checkDigit = (10 - (checkDigit % 10)) % 10

    const isCorrectDigit = checkDigit === Number(input[12])
    !isCorrectDigit && setError(`${t("eanIncorrectCheck")} ${checkDigit}`)
    return isCorrectDigit
  }

  useEffect(() => {
    if (isAte) {
      setEanCodeImg(ateEanCode)
    } else if (isConti) {
      setEanCodeImg(contiEanCode)
    } else {
      setEanCodeImg(contiEanCode)
    }
  }, [])

  const handleShowInfo = () => {
    setShowInfo(!showInfo)
  }

  const handleShowTextField = () => {
    setShowTextField(!showTextField)
  }

  const handleTextFieldChange = (e) => {
    setDecodedText(e.target.value)
    setData(e.target.value)
    localStorage.setItem("data", e.target.value)
  }

  return (
    <ResponsiveBackground theme={theme}>
      <Container
        sx={{ display: "flex", flexDirection: "column", height: "100%" }}
      >
        <Box
          sx={{
            display: "flex",
            justifyContent: "start",
            flexDirection: "column",
            padding: isMobile ? "0" : "0px 20px",
          }}
        >
          <Box>
            <Box>
              {window.innerWidth < breakpointTablet + 200 && (
                <>
                  {!isMobile && (
                    <Typography sx={{ marginBottom: "20px" }} variant={"body1"}>
                      {t("helpText")}
                    </Typography>
                  )}
                  <Box
                    width={isMobile ? "243px" : "100%"}
                    height={isMobile ? "45px" : null}
                  >
                    <ContiSpecificButton
                      text={t("scanCode")}
                      onClick={() => setShowScan(true)}
                      isBarcode={true}
                    ></ContiSpecificButton>
                  </Box>
                  <Box
                    marginTop={"20px"}
                    marginRight={"0px"}
                    marginBottom={"5px"}
                    marginLeft={isMobile ? "3px" : "0px"}
                    alignItems={"end"}
                    display={"flex"}
                  >
                    <Button
                      onClick={handleShowTextField}
                      style={{
                        color: "#000",
                        padding: "2px",
                        textTransform: "none",
                      }}
                    >
                      <Typography>{t("manualEntry")}</Typography>
                      <ArrowForwardIosIcon style={{ fontSize: "15px" }} />
                    </Button>
                  </Box>
                </>
              )}

              <Box sx={{ display: !showTextField ? "none" : null }}>
                {window.innerWidth > breakpointTablet && (
                  <Typography
                    sx={{ marginBottom: "15px", marginTop: "10px" }}
                    variant={"body1"}
                  >
                    {t("helpTextTablet")}
                  </Typography>
                )}
                <FormControl fullWidth>
                  <Box
                    sx={{
                      display: "flex",
                      flexDirection: "row",
                      flexFlow: isMobile ? "row wrap" : null,
                      justifyContent: isMobile ? "space-between" : null,
                      alignItems: "center",
                    }}
                  >
                    <StyledTextField
                      fullWidth={window.innerWidth > breakpointTablet}
                      id="outlined-basic"
                      variant="outlined"
                      placeholder={showPlaceholder ? "4 006633 444729" : ""}
                      onChange={handleTextFieldChange}
                      value={decodedText}
                      type={"text"}
                      onKeyDown={handleKeyDown}
                      InputLabelProps={{ shrink: false }}
                      inputProps={{ min: 0, style: { textAlign: "center" } }}
                      InputProps={{
                        style: {
                          borderRadius: "30px",
                          marginTop: "15px",
                          textAlign: "center",
                          fontFamily: isAte
                            ? "Etelka Light"
                            : isVDO
                            ? fonts_VDO.fontFamily
                            : "ContinentalStagSans-Light",
                          fontSize: "18px",
                          lineHeight: "26px",
                          letterSpacing: "3px",
                          width: "100%",
                          height: isMobile ? "32px" : undefined,
                          minWidth: isMobile ? null : "250px",
                          padding: null,
                          backgroundColor: "#ffff",
                        },
                      }}
                      style={
                        isMobile
                          ? { flex: "0 0 70%" }
                          : {
                              minWidth: "200px",
                            }
                      }
                      onFocus={() => setShowPlaceholder(false)}
                      onBlur={() => setShowPlaceholder(true)}
                    />
                    <Box
                      sx={
                        isMobile ? {} : { marginLeft: "15px", margnTop: "10px" }
                      }
                    >
                      <ContiSpecificButton
                        onClick={onClickHandle}
                        isForwardIcon={true}
                        width={isMobile ? "auto" : "30px"}
                        isFlexFlow={true}
                      ></ContiSpecificButton>
                    </Box>
                  </Box>
                </FormControl>
                <Typography
                  sx={{ textAlign: "left" }}
                  variant={"body2"}
                  color={theme.palette.error.main}
                >
                  {error}
                </Typography>
              </Box>
            </Box>

            <Box />
          </Box>
          <Box sx={{ padding: "30px 0px", paddingLeft: "0px" }}>
            <Box
              sx={{
                display: "flex",
                flexDirection: "row",
              }}
            >
              <InfoOutlinedIcon onClick={handleShowInfo} />

              <Typography
                sx={{
                  fontSize: "16px",
                  fontWeight: "500",
                  lineHeight: "24px",
                  marginLeft: "5px",
                }}
              >
                {t("EANCodeInfo")}
              </Typography>
            </Box>
            <Box sx={{ paddingTop: "10px", paddingLeft: "10px" }}>
              <Typography
                sx={{
                  marginBottom: "20px",
                  display: !showInfo ? "none" : null,
                }}
              >
                {t("EANCodeInfoProduct")}
              </Typography>
              {showInfo ? (
                <img
                  src={eanCodeImg}
                  width="70%"
                  height={"70%"}
                  alt=""
                  style={{
                    display: "flex",
                    justifyContent: "center",
                    margin: "0 auto",
                    padding: "10px 0px",
                    maxWidth: "400px",
                  }}
                ></img>
              ) : null}
            </Box>
          </Box>

          {showScan && (
            <Dialog
              open={true}
              onClose={() => setShowScan(false)}
              closeStyle={{
                color: theme.palette.text.primary,
                label: t("close"),
              }}
              title={t("scanCode")}
              text={""}
            >
              <div
                style={{
                  width: 278,
                  height: 278,
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                  borderRadius: "10px",
                  overflow: "hidden",
                }}
              >
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  viewBox="0 0 512 512"
                  style={{
                    width: 278,
                    height: 278,
                    display: "block",
                    position: "absolute",
                  }}
                >
                  <path
                    d="M336 448h56a56 56 0 0056-56v-56M448 176v-56a56 56 0 00-56-56h-56M176 448h-56a56 56 0 01-56-56v-56M64 176v-56a56 56 0 0156-56h56"
                    fill="none"
                    stroke={scanSuccess ? "#28a745" : "white"}
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth="10"
                  />
                </svg>
                <BarcodeScannerComponent
                  width={278}
                  height={278}
                  videoConstraints={{
                    facingMode: "environment",
                    aspectRatio: 1,
                  }}
                  onUpdate={(err, result) => {
                    if (result) {
                      const data = result.getText()
                      if (data.length === 13) {
                        setScanSuccess(true)
                        localStorage.setItem("data", data)
                        setDecodedText(data)
                        setShowScan(false)
                        setShowTextField(true)
                        redirectLocation(data)
                      } else {
                        setScanSuccess(false)
                      }
                    }
                  }}
                />
              </div>
            </Dialog>
          )}
        </Box>
      </Container>
    </ResponsiveBackground>
  )
}

export default SecondScan
